import _default from './Search';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Search/index.js
// module id = 1598
// module chunks = 0